import { Component, Input } from '@angular/core';
import { ErrCode } from '../../models';
import { DialogConfig } from '@material-library';

@Component({
  selector: 'app-dialog-error',
  templateUrl: './dialog-error.component.html',
  styleUrls: ['./dialog-error.component.scss']
})
export class DialogErrorComponent {
  
  @Input() public errcode: ErrCode;
  @Input() openState: number;
  @Input() public dialogConfig: DialogConfig;

}
